var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "login-change" } }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle",
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-user mr-1 d-sm-none",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "hidden-xs-down" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginHello", {
                        username: _vm.username,
                      })
                    ) +
                    "\n            "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-menu dropdown-menu dropdown-menu-right small m-0 p-0",
            },
            [
              _c(
                "div",
                {
                  staticClass: "list-group",
                  attrs: { "aria-labelledby": "accountMenuList" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "list-group-item small",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _c("i", { staticClass: "fa fa-user" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginMyAccount")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      staticClass: "list-group-item small",
                      attrs: { href: "#" },
                    },
                    [
                      _c("i", { staticClass: "fa fa-sign-out" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginLogout")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: _vm.isLogin ? "javascript:void(0)" : "#login",
                "data-toggle": _vm.isLogin ? false : "modal",
              },
              on: {
                click: function ($event) {
                  _vm.createLoginModal()
                  _vm.unmarkInputFields()
                },
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-sign-in",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-block d-md-inline-block" }, [
                _vm._v(
                  "\n                 " +
                    _vm._s(_vm.$translate("Ceres::Template.login")) +
                    "\n            "
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }